import { StaffMemberDetails } from '@/types/staff';
import { Card, Typography } from '@mui/material';
import { ROUTES } from '@/constants/routes';
import { SVLink } from '../core';

type StaffDetailsViewProps = {
  staffDetails: StaffMemberDetails;
};

export default function StaffDetailsView({
  staffDetails,
}: StaffDetailsViewProps) {
  if (staffDetails.companies.length === 0) {
    return null;
  }

  return (
    <Card variant="fullHeight">
      <Typography variant="h5" mb={2}>
        View
      </Typography>
      <SVLink to={`${ROUTES.COMPANIES}?staffId=${staffDetails.uuid}`}>
        Companies ({staffDetails.companies.length})
      </SVLink>
    </Card>
  );
}
